var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.course
    ? _c(
        "div",
        { staticClass: "intl-course-learn" },
        [
          _c("IntlBreadcrumb", { attrs: { "detail-title": _vm.courseTitle } }),
          _vm._v(" "),
          _c("div", { staticClass: "intl-course-learn__head" }, [
            _c("div", [
              _c("span", { staticClass: "intl-course-learn__type" }, [
                _vm._v(_vm._s(_vm.courseType)),
              ]),
              _vm._v(" "),
              _c("h1", [_vm._v(_vm._s(_vm.courseTitle))]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.course.description))]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "intl-course-learn__progress" }, [
              _c("span", [_vm._v(_vm._s(_vm.$t("common.progress")))]),
              _vm._v(" "),
              _c("strong", [_vm._v(_vm._s(_vm.progress) + "%")]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "intl-course-learn__body" }, [
            _c(
              "aside",
              { staticClass: "intl-course-learn__menu" },
              _vm._l(_vm.chapterTree, function (chapter) {
                return _c(
                  "div",
                  {
                    key: chapter.id,
                    staticClass: "intl-course-learn__chapter",
                    class: { "is-active": _vm.isActiveChapter(chapter) },
                    attrs: { role: "button", tabindex: "0" },
                    on: {
                      click: function ($event) {
                        return _vm.selectChapter(chapter)
                      },
                      keydown: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.selectChapter(chapter)
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "title" }, [
                      _vm._v(_vm._s(chapter.title)),
                    ]),
                    _vm._v(" "),
                    _vm.completedIds.includes(chapter.id)
                      ? _c("i", { staticClass: "state" }, [
                          _vm._v(_vm._s(_vm.$t("common.completed"))),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(chapter.children, function (child) {
                      return _c(
                        "span",
                        {
                          key: child.id,
                          staticClass: "child",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.selectChapter(child)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(child.title) +
                              "\n          "
                          ),
                          _vm.completedIds.includes(child.id)
                            ? _c("i", { staticClass: "state" }, [
                                _vm._v(_vm._s(_vm.$t("common.completed"))),
                              ])
                            : _vm._e(),
                        ]
                      )
                    }),
                  ],
                  2
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "section",
              { staticClass: "intl-course-learn__content" },
              [
                _vm.selectedChapter
                  ? [
                      _c("h2", [_vm._v(_vm._s(_vm.selectedChapter.title))]),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "rich",
                        domProps: {
                          innerHTML: _vm._s(_vm.selectedChapter.content),
                        },
                      }),
                      _vm._v(" "),
                      _vm.selectedResources.length
                        ? _c(
                            "div",
                            { staticClass: "resources" },
                            [
                              _c("h3", [
                                _vm._v(
                                  _vm._s(_vm.$t("common.learningResources"))
                                ),
                              ]),
                              _vm._v(" "),
                              _vm._l(
                                _vm.selectedResources,
                                function (resource, index) {
                                  return _c(
                                    "div",
                                    { key: index, staticClass: "resource" },
                                    [
                                      _vm.resourceType(resource) === "image"
                                        ? _c("img", {
                                            attrs: {
                                              src: _vm.resourceUrl(resource),
                                              alt: _vm.resourceName(resource),
                                            },
                                          })
                                        : _vm.resourceType(resource) === "video"
                                        ? _c("video", {
                                            attrs: {
                                              src: _vm.resourceUrl(resource),
                                              controls: "",
                                              preload: "metadata",
                                            },
                                          })
                                        : _vm.resourceType(resource) === "audio"
                                        ? _c("audio", {
                                            attrs: {
                                              src: _vm.resourceUrl(resource),
                                              controls: "",
                                              preload: "metadata",
                                            },
                                          })
                                        : _vm.resourceType(resource) === "embed"
                                        ? _c("iframe", {
                                            attrs: {
                                              src: _vm.resourceUrl(resource),
                                              title: _vm.resourceName(resource),
                                            },
                                          })
                                        : _c("div", { staticClass: "file" }, [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.resourceName(resource)
                                                )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "actions" },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href: _vm.resourceUrl(
                                                        resource
                                                      ),
                                                      target: "_blank",
                                                      rel: "noopener",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "common.openResource"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href: _vm.resourceUrl(
                                                        resource
                                                      ),
                                                      download: "",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "common.downloadResource"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]),
                                    ]
                                  )
                                }
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "learning-actions" }, [
                        _c(
                          "button",
                          {
                            staticClass: "ghost",
                            attrs: { disabled: !_vm.previousChapter },
                            on: {
                              click: function ($event) {
                                return _vm.goChapter(_vm.previousChapter)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("common.prevLesson")))]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "learning-actions__main" }, [
                          _c(
                            "button",
                            {
                              staticClass: "ghost",
                              on: {
                                click: function ($event) {
                                  return _vm.toggleCompleted(
                                    _vm.selectedChapter.id
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.completedIds.includes(
                                      _vm.selectedChapter.id
                                    )
                                      ? _vm.$t("common.markIncomplete")
                                      : _vm.$t("common.markComplete")
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "primary",
                              attrs: { disabled: !_vm.nextChapter },
                              on: {
                                click: function ($event) {
                                  return _vm.goChapter(_vm.nextChapter)
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("common.nextLesson")))]
                          ),
                        ]),
                      ]),
                    ]
                  : _vm.course.courseUrl
                  ? [
                      _c("h2", [
                        _vm._v(_vm._s(_vm.$t("common.externalCourse"))),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "external-tip" }, [
                        _vm._v(_vm._s(_vm.course.description)),
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "primary external-link",
                          attrs: {
                            href: _vm.course.courseUrl,
                            target: "_blank",
                            rel: "noopener",
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.openExternalCourse")))]
                      ),
                    ]
                  : _c("div", { staticClass: "empty" }, [
                      _vm._v(_vm._s(_vm.$t("common.noCourseContent"))),
                    ]),
              ],
              2
            ),
          ]),
        ],
        1
      )
    : _c("div", { staticClass: "intl-course-learn__loading" }, [
        _vm._v(
          "\n  " +
            _vm._s(
              _vm.loadFailed
                ? _vm.$t("common.contentUnavailable")
                : _vm.$t("common.loading")
            ) +
            "\n"
        ),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }